// Build and download a vCard (.vcf) from a member's public profile fields.

function esc(value) {
  if (value === null || value === undefined) return "";
  return String(value)
    .replace(/\\/g, "\\\\")
    .replace(/\n/g, "\\n")
    .replace(/,/g, "\\,")
    .replace(/;/g, "\\;");
}

export function buildVCard(m) {
  if (!m) return "";
  const lines = ["BEGIN:VCARD", "VERSION:3.0"];

  if (m.name) {
    lines.push(`FN:${esc(m.name)}`);
    const parts = m.name.trim().split(/\s+/);
    const first = parts[0] || "";
    const last = parts.length > 1 ? parts.slice(1).join(" ") : "";
    lines.push(`N:${esc(last)};${esc(first)};;;`);
  }
  if (m.title) lines.push(`TITLE:${esc(m.title)}`);

  const org = m.company || m.business?.business_name;
  if (org) lines.push(`ORG:${esc(org)}`);

  const email = m.email || m.business?.email;
  if (email) lines.push(`EMAIL;TYPE=INTERNET:${esc(email)}`);

  const phone = m.phone || m.business?.phone;
  if (phone) lines.push(`TEL;TYPE=CELL:${esc(phone)}`);

  const url = m.website || m.business?.website || m.linkedin;
  if (url) lines.push(`URL:${esc(url)}`);

  if (m.location_text) lines.push(`ADR;TYPE=WORK:;;${esc(m.location_text)};;;;`);

  const noteBits = [];
  if (m.bio) noteBits.push(m.bio);
  noteBits.push("Met via Friday Conversations");
  lines.push(`NOTE:${esc(noteBits.join(" — "))}`);

  lines.push("END:VCARD");
  return lines.join("\r\n");
}

export function downloadVCard(m) {
  const vcf = buildVCard(m);
  if (!vcf) return;
  const blob = new Blob([vcf], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(m.name || "contact").replace(/\s+/g, "-").toLowerCase()}.vcf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
